import api from '../../../services/api';
import buildQuery from 'odata-query'
import _ from 'lodash'

export const APPROVAL_URL = '/workflow'
export const APPROVERS_URL = '/approver'

// Pega todas as LPP
export function getAllApproval() {
  return api.get(APPROVAL_URL)
}

/*
export function fetchDataTable(idFactory) {
  return api.get(`${APPROVAL_URL}/odata/` + buildQuery({
    filter: 'standard/structure/factoryId+eq+' + idFactory,
    select: ['*'],
    expand: {
      standard: {
        select: ['identifier', 'name', 'standardType', 'userId'],
        expand: {
          structure: {
            select: ['name', 'id']
          }
        }
      },
      users: {
        select: ['order', 'situation'],
        expand: {
          user: {
            select: ['id', 'name']
          }
        }
      }
    }
  }))
}
*/
/**
 * 
 * @param {import('odata-query').QueryOptions<any>} odataQuery 
 * @returns {ApiOdataResponse<Workflow>}
 */
export function fetchTableOdata(odataQuery) {
  // _.merge the 2 odataquery
  return api.get(`${APPROVAL_URL}/odata/` + buildQuery(_.merge(
    odataQuery,
    {
      select: ['*'],
      expand: {
        standard: {
          select: ['identifier', 'name', 'standardType', 'userId'],
          expand: {
            structure: {
              select: ['name', 'id']
              },
              user: {
                  select: ['name']
              }
          }
        },
        users: {
          select: ['order', 'situation'],
          expand: {
            user: {
              select: ['id', 'name']
            }
          }
        }
      },
      count: true,
    }
  )))
}

/**
 * 
 * @param {import('odata-query').QueryOptions<any>} odataQuery 
 * @returns {ApiOdataResponse<Workflow>}
 */
export function fetchTableFunilOdata(odataQuery, filterFunilAuthorship) {
  // _.merge the 2 odataquery
    console.log('filterFunilAuthorship', filterFunilAuthorship)

    const query = buildQuery(_.merge(
        {
            select: ['*'],
            expand: {
                ManagerGTMApprovalUser: {
                    select: ['name', 'id']
                },
                ManagerGTAApprovalUser: {
                    select: ['name', 'id']
                },
                SHEApprovalUser: {
                    select: ['name', 'id']
                },
                Funil: {
                    select: ['id'],
                    expand: {
                        structure: {
                            select: ['name', 'id']
                        },
                        GTMUser: {
                            select: ['name']
                        }
                    }
                },
            },
            count: true,
        }, odataQuery
    ));
    console.log('query', query);
    const idx = query.indexOf('filter=') + 'filter='.length;
    const editedQuery = query.slice(0, idx) + filterFunilAuthorship + query.slice(idx)
    console.log('editedQuery', editedQuery);
  return api.get(`FunilActivity/odata/` + editedQuery)
}

export function fetchDataOne(idFactory, id) {
  return api.get(`${APPROVAL_URL}/odata/` + buildQuery({
    filter: 'standard/structure/factoryId+eq+' + idFactory + ' and id+eq+' + id,
    select: ['*'],
    expand: {
      standard: {
        select: ['*'],
        expand: {
          structure: {
            select: ['name', 'id']
          }
        }
      },
      users: {
        select: ['order', 'situation'],
        expand: {
          user: {
            select: ['id', 'name', 'SAP'],
            expand: {
              companyRole: {
                select: ['name']
              }
            }
          }
        }
      }
    }
  }))
}

export function getDepartments(idFactory, idDepartment) {

  return api.get('user/odata' + buildQuery({
    filter: {
      factoryId: parseInt(idFactory),
      deparmentId: parseInt(idDepartment),
    },
    select: ['name', 'sap', 'id'],
    expand: {
      companyRole: {
        select: ['name']
      }
    }
  }
  ))
}

export function getDepartmentName(idDepartment) {

  return api.get('structure/odata' + buildQuery({
    filter: {
      id: parseInt(idDepartment)
    },
    select: ['name']
  }
  ))
}

// https://nams-pp-lppdev-app.azurewebsites.net/api/structure/odata?$select=id,FactoryId&$filter=standard/structure/factoryId+eq+1111&$expand=users($expand=user)
// https://nams-pp-lppdev-app.azurewebsites.net/api/structure/odata?$select=id,FactoryId&$filter=standard/structure/factoryId+eq+1111&$expand=users($expand=user,structure)

// Retorna os dados por filtro
export function getByFilters(queryParams) {
  return api.get(`${APPROVAL_URL}/odata${queryParams}`)
}

// Retorna a view
export function fetchDataView(id) {
  return api.get(`${APPROVAL_URL}/${id}`)
}

// Retorna a view pelo odata
export function fetchDataViewOdata(id) {
  return api.get(`${APPROVAL_URL}/odata` + buildQuery({
    filter: {
      id: parseInt(id)
    },
    expand: {
      users: true,
      standard: {
          select: ['standardType']        
      }
    },
  }))
}

export function updateApproval(approval) {
  return api.put(`${APPROVAL_URL}`, approval);
}

export function createApproval(workflow) {
  return api.post(`${APPROVAL_URL}`, workflow)
}

export async function getLppStandby(id) {

    let returnValue = {};
    const baseData = await api.get(`/StandardStandBy/odata/` + buildQuery({
        filter: {
            standardId: id,
            ProcessSituation: 'Pending',
        },
        select: ['alertProcedure', 'createdAt', 'id', 'standardId', 'identifier', 'name', 'productActivity',
            'standardType', 'station', 'status', 'version', 'Classification', 'Pilar', 'Transfer',
            'ApplicableToNewColleague', 'Description', 'DefectSource', 'Eliminated', 'ToolElimination',
            'KillerAction', 'EliminatedAt', 'ReactivationReason', 'ReactivationSource', 'ReactivateAt',
            'ConsumerImpact', 'ProcessImpact', 'Occurrence', 'Detection', 'ProductTechnology', 'PackingType',
            'PackingTechnology', 'TargetPublic','MaterialDescription', 'Category'],
        expand: {
            steps: true,
            structure: {
                select: ['name'],
                expand: {
                    father: {
                        select: ['name']
                    }
                }
            },
        }
    }))

    returnValue = baseData;

    const extraData = await api.get(`/StandardStandBy/odata/` + buildQuery({
        filter: {
            standardId: id,
            ProcessSituation: 'Pending',
        },
        select: ['id'],
        expand: {            
            equipments: {
                expand: {
                    equipment: {
                        select: ['name', 'photo', 'type']
                    }
                }
            },
            product: {
                select: ['*']
            },
            defectType: {
                select: ['*']
            },
            defectCategory: {
                select: ['*']
            },
            pillarResponsibility: {
                select: ['name']
            }
        }
    }))

    returnValue.data.value[0].trainingUsers = extraData.data.value[0].trainingUsers;
    returnValue.data.value[0].equipments = extraData.data.value[0].equipments;
    returnValue.data.value[0].product = extraData.data.value[0].product;
    returnValue.data.value[0].defectType = extraData.data.value[0].defectType;
    returnValue.data.value[0].defectCategory = extraData.data.value[0].defectCategory;
    returnValue.data.value[0].pillarResponsibility = extraData.data.value[0].pillarResponsibility;

    return returnValue;

}

// Retorna a view pelo odata
export async function getApproversAPI(factoryId, standardType, standardClassification) {
  let response;
  if (standardClassification == '') {
    response = await api.get(`${APPROVERS_URL}/odata` + buildQuery({
      filter: {
        'standardType': standardType,
        'user/factoryId': parseInt(factoryId)
        },        
        expand: {
            user: {
                select: ['name', 'id', 'sap'],
                expand: {
                    deparment: {
                        select: ['name']
                    },
                }
            }
        }        
    }))
  }
  else {
    response = await api.get(`${APPROVERS_URL}/odata` + buildQuery({
      filter: {
        'standardType': standardType,
        'standardClassification': standardClassification,
        'user/factoryId': parseInt(factoryId)
        },
        expand: {
            user: {
                select: ['name', 'id', 'sap'],
                expand: {
                    deparment: {
                        select: ['name']
                    },
                }
            }
        }   
    }))
  }

  return response;
}

// Retorna a view pelo odata
export async function getApproversPilarAPI(factoryId, standardType, standardClassification) {
    let response;    
    if (standardType.toUpperCase() == 'LPP') {
        response = await api.get(`${APPROVERS_URL}/odata` + buildQuery({
            filter: {                
                'standardClassification': standardClassification,
                'user/factoryId': parseInt(factoryId),
                'user/status': true
            },
            expand: {
                user: {
                    select: ['name', 'id', 'sap'],
                    expand: {
                        deparment: {
                            select: ['name']
                        },
                    }
                }
            }
        }))
    }
    else {
        response = await api.get(`${APPROVERS_URL}/odata` + buildQuery({
            filter: {
                'standardType': standardType,
                'user/factoryId': parseInt(factoryId),
                'user/status': true
            },
            expand: {
                user: {
                    select: ['name', 'id', 'sap'],
                    expand: {
                        deparment: {
                            select: ['name']
                        },
                    }
                }
            }
        }))
    }
    

    return response;
}


export async function getMyApprovalsAPI(userId, factoryId) {
  let response;

  response = await api.get(`${APPROVERS_URL}/odata` + buildQuery({
    filter: {
      'user/id': parseInt(userId),
      'user/factoryId': parseInt(factoryId)
    },
    select: ['userId', 'standardClassification', 'standardType']
  }))

  return response;
}

export async function fetchStandardByIdentifier(standardId){

  let response = api.get(`StandardStandBy/odata/` + buildQuery({
    filter: {
      standardId: parseInt(standardId)
  },
  orderBy: 'Id desc',
  top: 1,
  count: true,
  select: ['pilar']
  }))
  return response
}